import React, { useRef, useEffect } from 'react';
import { McDialog, McTextarea, McButton, McIcon } from '@maersk-global/mds-react-wrapper/components-core';

interface SqlViewerDialogProps {
    open: boolean;
    onClose: () => void;
    versionInfo: any;
    sqlContent: string;
    canCreateVersions: boolean;
    onCreateVersion: () => void;
}

export const SqlViewerDialog: React.FC<SqlViewerDialogProps> = ({
    open,
    onClose,
    versionInfo,
    sqlContent,
    canCreateVersions,
    onCreateVersion
}) => {
    const latestOnClose = useRef(onClose);
    const latestOnCreateVersion = useRef(onCreateVersion);

    useEffect(() => { latestOnClose.current = onClose; }, [onClose]);
    useEffect(() => { latestOnCreateVersion.current = onCreateVersion; }, [onCreateVersion]);

    return (
        <McDialog
            open={open}
            heading={`SQL Content - Version ${versionInfo?.versionNumber}`}
            closed={onClose}
            width="1000px"
        >
            <div style={{ marginBottom: '16px' }}>
                <p className="mds-text--small-regular" style={{ color: 'var(--mds-color-neutral-weaker-text)' }}>
                    Created by {versionInfo?.createdBy} on {versionInfo?.createdAt ? new Date(versionInfo.createdAt).toLocaleDateString() : 'Unknown'}
                </p>
                {versionInfo?.changeDescription && (
                    <p className="mds-text--small-regular" style={{ color: 'var(--mds-color-neutral-weaker-text)', marginTop: '8px' }}>
                        {versionInfo.changeDescription}
                    </p>
                )}
            </div>

            <McTextarea
                value={sqlContent}
                label="SQL Query"
                readonly
                rows={15}
                style={{
                    width: '100%',
                    fontFamily: '"JetBrains Mono", "Monaco", "Menlo", monospace'
                }}
            />

            <McButton slot="secondaryAction" appearance="primary" variant="outlined" style={{ width: '160px' }} onClick={() => latestOnClose.current()}>Close</McButton>
            {canCreateVersions && (
                <McButton
                    slot="primaryAction"
                    appearance="primary"
                    onClick={() => {
                        latestOnClose.current();
                        latestOnCreateVersion.current();
                    }}
                    variant="filled"
                    style={{ width: '160px' }}
                >
                    <McIcon icon="plus" slot="prefix" />
                    New Version
                </McButton>
            )}
        </McDialog>
    );
};
